<div class="layout-auto-1-auto">
  <div></div>
  <div class="content">
    <div class="layout-list-quickfilter">
      <exg-search-bar class="span-layout" [placeholder]="getRessource('SearchHeaderPlaceholder')">
        <div></div>

        <ng-template #rightTemplate>
          <i class="search-action far fa-sync" flow="left" [tooltip]="getRessource('SearchHeaderSync')"
             (click)="config.questTable.loadData()"></i>
          <i class="search-action far fa-plus"
             flow="left" *ngIf="excSecurity.isFeatured('BONUSMALUSCREATE')"
             [tooltip]="(AvailableDateList?.length == 0)? 'Kein Zeitraum für Bewertungen verfügbar':'Neue Bewertung anlegen'"
             [ngClass]="{'disabled': AvailableDateList?.length == 0}"
             (click)="add()"></i>
          <!--          <i class="search-action far fa-filter" (click)="togglePopupMenu($event, 'filter')"></i>-->
          <!--          <exg-popup #filter [closeAlways]="false" width="360">-->
          <!--            <app-exg-filter [MetaInfo]="metaInfo" [uiFilter]="uiFilter" [uiSort]="uiSort" [showFilter]="true" (onActivateFilter)="closePopupMenuAndReload()"></app-exg-filter>-->
          <!--          </exg-popup>-->

          <!--          <i class="search-action far fa-sort-alt" (click)="togglePopupMenu($event, 'sort')"></i>-->
          <!--          <exg-popup #sort [closeAlways]="false" width="360" >-->
          <!--            <app-exg-filter [MetaInfo]="metaInfo" [uiSort]="uiSort" [uiFilter]="uiFilter" [showSort]="true" (onActivateFilter)="closePopupMenuAndReload()"></app-exg-filter>-->
          <!--          </exg-popup>-->

          <!--          <i class="search-action far fa-binoculars" (click)="togglePopupMenu($event, 'search')"></i>-->
          <!--          <exg-popup #search [closeAlways]="false" width="360">-->
          <!--            <app-exg-filter [MetaInfo]="metaInfo" [uiFilter]="uiFilter" [uiSort]="uiSort" [showSearch]="true" (onActivateFilter)="closePopupMenuAndReload()"></app-exg-filter>-->
          <!--          </exg-popup>-->
          <!--          <div class="vertical-separator"></div>-->
          <!--          <i class="search-action far fa-file-export" (click)="exportTaskList()"></i>-->
          <!--          <i class="search-action far fa-list" flow="left" [tooltip]="getRessource('SearchHeaderMulti')" [ngClass]="{'green':myTableMultiSelection}" (click)="toggleMultiSelection()"></i>-->
        </ng-template>
      </exg-search-bar>
      <div class="content">
        <exg-data-list #VCQuestTable
                       [rowSource]="questTable.data"
                       [selectKey]="config.questTable.selectKey"
                       [displayState]="config.questTable.state"
                       [allowSingleSelection]="true"
                       (RowChange)="config.questTable.selectionChanged($event)">
          <ng-template #rowTemplate let-row>
            <div class="list-row-auto-1">
              <div></div>
              <div class="layout-auto-1-auto-grid-1-auto grid typo-small">
                <div class="list-metadata" style="margin-left:0">
                  <div class="grid grid-auto-1">
                    <div class="width-100">
                      {{row.bmqMonth}} / {{row.bmqYear}}
                    </div>
                    <div>
                      <ng-container *ngIf="!row.bmqLCK && excSecurity.isFeatured('BONUSMALUSEDIT')">
                        <div class="search-action">
                          <i
                          class="fas fa-fw  fa-pencil" (click)="edit(row)"></i>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="row.bmqLCK || !excSecurity.isFeatured('BONUSMALUSEDIT')">
                        <i *ngIf="!excSecurity.isFeatured('BONUSMALUSUNLOCK')" class="fas fa-fw fa-lock"></i>
                        <div *ngIf="excSecurity.isFeatured('BONUSMALUSUNLOCK')" class="search-action">
                          <i class="fa-fw fas fa-lock" (click)="unlock(row)"></i>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <div></div>
                </div>
                <div class="list-metadata ">
                  <div
                    class="typo-right">
                    {{row.bmqLCD | excDate:getGlobal("DateTimeFormatShort")}}
                  </div>
                  <div class="typo-right">
                    {{row.bmqLCU}}
                  </div>
                </div>
                <div class="span-2 list-primary-text">
                  <div class="grid-1-auto">
                    <div style="margin-left: 0"><strong>Gesamt:
                      <i class="fa-star {{(row.bmqCalcSum >= -2)?'fas':'far'}}"></i>
                      <i class="fa-star {{(row.bmqCalcSum >= -1)?'fas':'far'}}"></i>
                      <i class="fa-star {{(row.bmqCalcSum >= -0)?'fas':'far'}}"></i>
                      <i class="fa-star {{(row.bmqCalcSum >= 1)?'fas':'far'}}"></i>
                      <i class="fa-star {{(row.bmqCalcSum == 2)?'fas':'far'}}"></i>
                      ({{row.bmqCalcSum}})
                    </strong></div>
                  </div>
                </div>
                <div class="span-2 list-secondary-text">
                  <div class="grid cols-4">
                    <div>Berichtsqualität:</div>
                    <div><i class="fa-star {{(row.bmqReportQuality >= -2)?'fas':'far'}}"></i>
                      <i class="fa-star {{(row.bmqReportQuality >= -1)?'fas':'far'}}"></i>
                      <i class="fa-star {{(row.bmqReportQuality >= -0)?'fas':'far'}}"></i>
                      <i class="fa-star {{(row.bmqReportQuality >= 1)?'fas':'far'}}"></i>
                      <i class="fa-star {{(row.bmqReportQuality == 2)?'fas':'far'}}"></i>
                      ({{row.bmqReportQuality}})
                    </div>
                    <div>Einsatzbereitschaft:</div>
                    <div><i class="fa-star {{(row.bmqOperationalReadiness >= -2)?'fas':'far'}}"></i>
                      <i class="fa-star {{(row.bmqOperationalReadiness >= -1)?'fas':'far'}}"></i>
                      <i class="fa-star {{(row.bmqOperationalReadiness >= -0)?'fas':'far'}}"></i>
                      <i class="fa-star {{(row.bmqOperationalReadiness >= 1)?'fas':'far'}}"></i>
                      <i class="fa-star {{(row.bmqOperationalReadiness == 2)?'fas':'far'}}"></i>
                      ({{row.bmqOperationalReadiness}})
                    </div>
                    <div>Bearbeitungsqualität:</div>
                    <div><i class="fa-star {{(row.bmqProcessingQuality >= -2)?'fas':'far'}}"></i>
                      <i class="fa-star {{(row.bmqProcessingQuality >= -1)?'fas':'far'}}"></i>
                      <i class="fa-star {{(row.bmqProcessingQuality >= -0)?'fas':'far'}}"></i>
                      <i class="fa-star {{(row.bmqProcessingQuality >= 1)?'fas':'far'}}"></i>
                      <i class="fa-star {{(row.bmqProcessingQuality == 2)?'fas':'far'}}"></i>
                      ({{row.bmqProcessingQuality}})
                    </div>
                    <div>Fristen-/SLA-Einhaltung:</div>
                    <div><i class="fa-star {{(row.bmqSLAObservance >= -2)?'fas':'far'}}"></i>
                      <i class="fa-star {{(row.bmqSLAObservance >= -1)?'fas':'far'}}"></i>
                      <i class="fa-star {{(row.bmqSLAObservance >= -0)?'fas':'far'}}"></i>
                      <i class="fa-star {{(row.bmqSLAObservance >= 1)?'fas':'far'}}"></i>
                      <i class="fa-star {{(row.bmqSLAObservance == 2)?'fas':'far'}}"></i>
                      ({{row.bmqSLAObservance}})
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </ng-template>
        </exg-data-list>
      </div>
      <div></div>
      <exg-pager (PageChange)="config.questTable.pageChanged($event)" *ngIf="true"
                 [pagingSource]="questTable.paging">
        <!--        <ng-template #leftTemplate>
                  <app-exg-dropdown class="typo-small" [list]="preFilterDefinition" elementclass="typo-left" maxHeight="250px"
                                    [label]="selectedMod.caption" position="abovecenter" listdisplay="caption"
                                    (change)="changePreFilterMod($event.value)" >
                  </app-exg-dropdown>
                  <app-exg-dropdown class="typo-small" [list]="selectedMod.types" elementclass="typo-left" maxHeight="250px"
                                    [label]="selectedType.caption" position="abovecenter" listdisplay="caption"
                                    (change)="changePreFilterType($event.value)">
                  </app-exg-dropdown>
                </ng-template>
                <ng-template #rightTemplate>
                  <div class="app-pager-chips">
                    <app-exg-filter-chips #VCFilterChips
                                          [inputDataTable]="taskTable"
                                          [VCFilterControl]="{ VCFilter: VCtaskTableFilterControl, VCSearch: VCtaskTableSearchControl, VCSort: VCtaskTableSortControl}">
                    </app-exg-filter-chips>
                  </div>
                </ng-template>-->
      </exg-pager>
    </div>
  </div>
</div>
